module.exports = __webpack_public_path__ + "static/img/kurtka_g.fbeaa75e.webp";